const $ = require('jquery');

const preventSubmit = function() {
	$('form:not(.js-submit-on-enter) input:not(#search)').on('keydown', function(){
		if(event.keyCode == 13) {
			event.preventDefault();
			return false;
		}
	});
	$('#search-form').on('submit', function(){
		if($("#search").val() == '/') {
			$("#search").val('');
			event.preventDefault();
			return false;
		}
	});
};

module.exports = preventSubmit;
